@if (loginState$ | async; as loginState) {
  <div
    [class.stage-hidden]="$stage() !== Stage.WELCOME"
    class="page-body welcome-stage"
  >
    <intro-flow-welcome-view></intro-flow-welcome-view>

    <button mat-flat-button (click)="$stage.set(Stage.SIGN_IN)">
      <mat-icon class="fill">phone</mat-icon>
      Continue with Phone
    </button>
  </div>

  <div class="page-body" [class.stage-hidden]="$stage() !== Stage.SIGN_IN">
    <div
      class="welcome-section"
      [class.fade]="loginState > LoginState.PHONE_INPUT"
    >
      <div class="welcome-text">
        <div class="title-large">
          {{ contextText() ? contextText() : "Let's get started!" }}
        </div>
      </div>

      <div class="phone-number-input">
        <phone-number-input
          [formControl]="phoneNumberCtrl"
          (keyup.enter)="requestCode()"
          #phoneInput
        ></phone-number-input>
      </div>
      @if (loginFailedMessage$ | async; as loginFailedMessage) {
        <div class="signin-failed label-medium error-text">
          {{ loginFailedMessage }}
        </div>
      }
    </div>

    <div
      class="code-sent-section"
      [class.visible]="loginState >= LoginState.CODE_INPUT"
    >
      <div class="title-small">Verification code sent!</div>
      <mat-form-field
        appearance="outline"
        class="verification-code-field"
        floatLabel="always"
      >
        <mat-label>Verification Code</mat-label>
        <input
          matInput
          [formControl]="verificationCtrl"
          inputmode="numeric"
          (keyup.enter)="submitCode()"
          #verifyInput
        />

        @if (codeInputError$ | async; as error) {
          <ng-container>
            <mat-hint class="error-text">{{ error }}</mat-hint>
          </ng-container>
        }
      </mat-form-field>
    </div>

    <div class="actions">
      @if (loginState < LoginState.CODE_INPUT) {
        <button
          mat-flat-button
          class="send-code-btn"
          (click)="requestCode()"
          [disabled]="
            (validPhoneNumber$ | async) === undefined ||
            loginState > LoginState.PHONE_INPUT
          "
        >
          @if (loginState < LoginState.CODE_REQUESTED) {
            <span>Send Code</span>
          } @else if (loginState === LoginState.CODE_REQUESTED) {
            <mat-spinner diameter="20"></mat-spinner>
          }
        </button>
      } @else if (loginState >= LoginState.CODE_INPUT) {
        <button
          mat-button
          class="back-btn error-button"
          (click)="handleBack()"
          [disabled]="loginState !== LoginState.CODE_INPUT"
        >
          Back
        </button>

        <button
          mat-flat-button
          class="verify-btn"
          (click)="submitCode()"
          [disabled]="
            (validVerificationCode$ | async) === undefined ||
            loginState >= LoginState.VERIFYING_CODE
          "
        >
          @if (loginState < LoginState.VERIFYING_CODE) {
            <span>Verify</span>
          } @else if (loginState >= LoginState.VERIFYING_CODE) {
            <mat-spinner diameter="20"></mat-spinner>
          }
        </button>
      }
    </div>

    <div class="tos-pp body-small">
      By continuing, you agree to our
      <a
        class="primary-text"
        href="https://www.termsfeed.com/live/84cc9c9a-6ed3-4025-b6b9-91fb24273fa1"
        target="_blank"
        >Terms of Service</a
      >
      and
      <a
        class="primary-text"
        href="https://www.termsfeed.com/live/22c0bb67-dcc8-4b2f-859e-2df0b7a873d1"
        target="_blank"
        >Privacy Policy</a
      >
      and consent to receive text messages. Message and data rates may apply.
    </div>
  </div>

  <div
    class="page-footer on-surface-text"
    [class.stage-hidden]="$stage() !== Stage.SIGN_IN"
  >
    @if (isDevMode()) {
      <button mat-button class="dev-login" (click)="handleDevLogin('juanda')">
        [Dev] Login as Juanda
      </button>

      <button mat-button (click)="handleDevLogin('new')">
        [Dev] Create User
      </button>
    }
  </div>

  <div id="recaptcha-container"></div>
}
